import { Observable } from 'rxjs';
import {
  Mezzo,
  CreateMezzoDto,
  UpdateMezzoDto,
  AddManutenzioneDto,
  MezzoQueryParams,
  PaginatedResponse,
  TipologiaMezzo,
  MezzoManutenzione,
  StoricoManutenzioniQueryParams,
  MezzoAssociazione,
  StoricoAssociazioniQueryParams, AssociateToDipendenteDto, StatoMezzo,
} from '../../models/garage.model';

export type GarageListResult =
  | { notModified: true }
  | { notModified: false; response: PaginatedResponse<Mezzo> };

export abstract class GaragePort {
  abstract getList(params?: MezzoQueryParams): Observable<GarageListResult>;
  abstract getById(id: number): Observable<Mezzo>;
  abstract create(dto: CreateMezzoDto, scheda?:any): Observable<number>;
  abstract update(id: number, dto: UpdateMezzoDto): Observable<number>;
  abstract associateToCantiere(id: number, idCantiere: number): Observable<number>;
  abstract endCantiereAssociation(id: number): Observable<number>;
  abstract addManutenzione(dto: AddManutenzioneDto): Observable<number>;
  abstract getStoricoManutenzioni(params?: StoricoManutenzioniQueryParams): Observable<PaginatedResponse<MezzoManutenzione>>;
  abstract getStoricoAssociazioni(params?: StoricoAssociazioniQueryParams): Observable<PaginatedResponse<MezzoAssociazione>>;
  abstract getTipologieMezzi(): Observable<PaginatedResponse<TipologiaMezzo>>;
  abstract createTipologiaMezzo(tipo: string): Observable<number>;
  abstract deleteTipologiaMezzo(id: number): Observable<number>;
  abstract associateToDipendente(dto: AssociateToDipendenteDto): Observable<number>;
  abstract endDipendenteAssociation(id: number, kmRitorno: number, dataRitorno: string): Observable<number>;
  abstract setUsability(id: number, stato: StatoMezzo): Observable<number>;
}
